import { graphql } from 'react-relay';

import { WorkbookWindowPaginator_query$key } from '../../../relay/__generated__/WorkbookWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const WorkbookWindowPaginator_query = graphql`
  fragment WorkbookWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: WorkbookFilter }
    order: { type: WorkbookOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "WorkbookWindowPaginatorRefreshQuery") {
    workbooks(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...WorkbookConnectionDataTable_workbookConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<WorkbookWindowPaginator_query$key>, 'fragment'>;

const WorkbookWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={WorkbookWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.workbooks.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default WorkbookWindowPaginator;
